export { getFirstKeyFromCollectionMechanic } from './get-first-key-from-collection-mechanic';
